document.addEventListener('DOMContentLoaded', () => {
  const trackerElm = document.querySelector('.first-visit-tracker');
  if (!trackerElm) return;
  if (!trackerElm.dataset) return;

  let { cookieName } = trackerElm.dataset;

  if (cookieName === undefined) {
    cookieName = '_wecasa_first_visit';
  }

  if (document.cookie.split(';').some((c) => c.trim().startsWith(`${cookieName}=`))) {
    return;
  }

  const truncate = (str, len) => (str ? str.substring(0, len) : null);
  const trackingData = {
    destination: truncate(window.location.href, 1000),
    referrer: truncate(document.referrer, 1000),
  };

  const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
  const json = encodeURIComponent(JSON.stringify(trackingData));
  document.cookie = `${cookieName}=${json}; expires=${expires}; path=/; SameSite=Lax`;
});
